import React from 'react';

import Header from '../Category/Header/Header';
import Overview from '../Category/Overview/Overview';

import './DealComplexityOverview.scss';

const DealComplexityOverview = ({ selectedCategory, categories, onChange }) => (
  <Overview
    category={selectedCategory}
    onScoreChange={(newValue) =>
      onChange(selectedCategory.categoryId, { value: newValue })
    }
    onDescriptionChange={(newDescription) =>
      onChange(selectedCategory.categoryId, { description: newDescription })
    }
  >
    {categories
      .filter((cat) => cat.parentId === undefined)
      .map((category) => (
        <div className="category" key={`${category.title}-div`}>
          <Header key={category.title} category={category} />
        </div>
      ))}
  </Overview>
);

export default DealComplexityOverview;
